/**
 * Mensaje de confirmación antes de borrar una fila de matriz: si la usan cotizaciones abiertas (no Aceptadas),
 * dice cuáles y qué les pasará al recalcularlas. Las Aceptadas no se recalculan, así que no se afectan.
 */
export const mensajeBorradoFilaMatriz = (uso: string[], consecuencia: string, mensajeSinUso: string) => {
    if (uso.length === 0) return mensajeSinUso;
    const nombres = uso.slice(0, 5).join(', ') + (uso.length > 5 ? ` y ${uso.length - 5} más` : '');
    const cuantas = uso.length === 1 ? '1 cotización abierta' : `${uso.length} cotizaciones abiertas`;
    return `Esta fila la usan ${cuantas} (${nombres}). ${consecuencia} ¿Deseas eliminarla?`;
};
